import { NavLink, useLocation } from 'react-router-dom';
import { FileText, Users } from 'lucide-react';
import { ROUTES } from '../../constants/routes';
import { useLanguage } from '../../contexts/LanguageContext';

const TABS = [
  { path: ROUTES.DOCTOR_PATIENTS, labelKey: 'doctorPatients', icon: Users, tourId: 'doctor-nav-patients' },
  { path: ROUTES.DOCTOR_NOTES, labelKey: 'doctorNotes', icon: FileText, tourId: 'doctor-nav-notes' },
];

const HIDE_PREFIXES = [
  '/doctor/signup',
  '/doctor/login',
  '/doctor/onboarding',
  '/doctor/paywall',
];

export default function DoctorBottomNav() {
  const location = useLocation();
  const { t } = useLanguage();

  const hide =
    HIDE_PREFIXES.some((p) => location.pathname.startsWith(p)) ||
    location.pathname.includes('/generating') ||
    location.pathname.includes('/review');

  if (hide) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-gray-200 bg-surface pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_12px_rgba(0,0,0,0.08)]">
      <div className="mx-auto flex max-w-lg items-stretch justify-around px-2 py-2">
        {TABS.map(({ path, labelKey, icon: Icon, tourId }) => {
          const active =
            location.pathname === path ||
            (path === ROUTES.DOCTOR_PATIENTS && location.pathname.startsWith('/doctor/patients')) ||
            (path === ROUTES.DOCTOR_NOTES && location.pathname.startsWith('/doctor/notes'));
          return (
            <NavLink
              key={path}
              to={path}
              data-tour={tourId}
              className={`flex min-w-[88px] flex-col items-center gap-1 rounded-xl px-3 py-2 text-xs font-semibold ${
                active ? 'text-primary' : 'text-gray-500'
              }`}
            >
              <Icon className="h-5 w-5" strokeWidth={2} />
              {t(labelKey)}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
